import { apiFetch, API_BASE } from '../shared/api/httpClient';

export function fetchNotificationState(options = {}) {
  return apiFetch(`${API_BASE}/api/notifications`, options);
}

export function fetchNotificationHistory({ beforeReadyAt, beforeId, limit = 20, signal } = {}) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (beforeReadyAt) params.set('before_ready_at', beforeReadyAt);
  if (beforeId) params.set('before_id', beforeId);
  return apiFetch(`${API_BASE}/api/notifications/history?${params.toString()}`, { signal });
}

export function markNotificationsRead(ticketIds, options = {}) {
  return apiFetch(`${API_BASE}/api/notifications/read`, {
    ...options,
    method: 'POST',
    body: JSON.stringify({ ticket_ids: Array.isArray(ticketIds) ? ticketIds : [] }),
  });
}

export function markAllNotificationsRead(options = {}) {
  return apiFetch(`${API_BASE}/api/notifications/read-all`, {
    ...options,
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function updateNotificationSettings(enabled, options = {}) {
  return apiFetch(`${API_BASE}/api/notifications/settings`, {
    ...options,
    method: 'PUT',
    body: JSON.stringify({ enabled: Boolean(enabled) }),
  });
}